import { exists } from 'base/helpers';
import { LibraryCache } from 'base/library_cache';
import { ProjectState } from 'blocks/editor/model';
import { unrefSection } from 'blocks/editor/model_helpers';
import { findOverridableImagesInElement } from 'blocks/editor/styleguide/images';

export async function getExtraProjectShareData(
  project: ProjectState,
  library: LibraryCache,
) {
  if (project.concepts.length === 0) {
    return;
  }

  const sectionPromises = project.homePage.sections.map(async (sref) => {
    const section = unrefSection(sref, project);
    if (section?.element.current?.id == null) {
      return null;
    }

    const images = await findOverridableImagesInElement(
      section.element.current,
      library,
    );

    const elementId = section.element.current.id;

    return {
      slug: section.element.current.source.slug,
      elementId,
      images,
      ref: section,
    };
  });

  const homepageSections = (await Promise.all(sectionPromises)).filter(exists);

  const concepts = project.concepts
    .filter((concept) => concept.galleryPosition != null)
    .map((concept) => {
      const homepage = homepageSections.map((section) => {
        const scheme = concept.schemeOverrideByElementId.get(section.elementId);
        const images = section.images.map(
          (image) => concept.images.get(image.key)?.type ?? 'empty',
        );

        return {
          slug: section.slug,
          scheme,
          images,
        };
      });

      return { homepage };
    });

  return { concepts };
}
